
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/drivers",
      function () {
        return require("private-next-pages/drivers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/drivers"])
      });
    }
  